<template>
  <div>
    <el-card class="box-card">
      <el-row :gutter="50" class="mb-1">
        <el-col :span="24" class="invitation-container">
          <div class="invitation">
            <span class="msg-1">
              invite publishers to
              <img
                src="@/apps/traforama/assets/images/referrals/asg-logo.png"
              />
            </span>
            <span class="msg-2"> work with them with zero fee </span>
          </div>
          <img
            src="@/apps/traforama/assets/images/referrals/money-guns.png"
            class="invite-img"
          />
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <el-row class="mb-1">
        <el-col :span="24" class="shares-container">
          <div class="link-box">
            <ReferralLink :domain="domain" />
            <el-row class="mt-1 btn-row">
              <el-button class="kit-btn" type="primary" round>
                <a href="/Adspyglass_referral.pdf" target="_blank"
                  >Download Media Kit</a
                >
              </el-button>
              <div class="advice">
                We recommend you sending the media kit to the referred
                publisher,
                <br />
                as it will make his experience easier with us.
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <h2>how it works</h2>
      <el-col :span="24" :lg="20" :xl="14" class="steps-container">
        <div class="step">
          <img src="@/apps/traforama/assets/images/referrals/step-1.png" />
          <div class="big-text">
            Copy the <b>referral link</b> & send to the publisher/website owner
          </div>
        </div>
        <div class="right-arrow">
          <img src="@/apps/traforama/assets/icons/arrow-right.png" />
        </div>
        <div class="step">
          <img src="@/apps/traforama/assets/images/referrals/step-2.png" />
          <div class="big-text">
            Your publisher joins
            <a href="https://adspyglass.com">AdSpyglass</a>
            & becomes available at <b>Traforama</b>
          </div>
        </div>
        <div class="right-arrow">
          <img src="@/apps/traforama/assets/icons/arrow-right.png" />
        </div>
        <div class="step">
          <img src="@/apps/traforama/assets/images/referrals/step-3.png" />
          <div class="big-text">
            You work with your publisher with <b>0 fee</b>
          </div>
        </div>
      </el-col>
    </el-card>

    <el-card class="box-card">
      <h2>What if I work with my publishers via other Ad Networks?</h2>
      <el-row>
        <el-col :span="24" class="big-text">
          In case your publisher works with any of the following ad networks
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" :lg="20" :xl="14" class="networks-container">
          <div v-for="icon in mainIcons" :key="icon" class="network-container">
            <img :src="`/source_info/${icon}`" />
          </div>
          <div class="more-link">
            <el-link @click="toggleNetworks">
              {{ btnText }}
            </el-link>
          </div>
        </el-col>
      </el-row>

      <el-col
        v-show="visible"
        :span="20"
        :lg="20"
        :xl="14"
        class="networks-container more-networks"
      >
        <div v-for="icon in icons" :key="icon" class="network-container">
          <img :src="`/source_info/${icon}`" />
        </div>
      </el-col>

      <el-row>
        <el-col :span="24" class="big-text opportunity">
          Invite publishers to join AdSpyglass, and they will be able to keep
          cooperating with their Ad Networks
          <br />
          while having a brilliant opportunity to work with you directly
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" :md="24" :lg="19" :xl="14" class="summary">
          <div class="item">
            <div>
              <img src="@/apps/traforama/assets/icons/chains.png" />
            </div>
            <div class="description">
              The invited publisher links their Ad Network account to the
              AdSpyglass system;
            </div>
          </div>
          <div class="item">
            <div>
              <img src="@/apps/traforama/assets/icons/money-people.png" />
            </div>
            <div class="description">
              The publisher continues working with their current ad network
              while simultaneously selling part of their traffic directly to
              you.
            </div>
          </div>
          <div class="item">
            <div>
              <img src="@/apps/traforama/assets/icons/income-icon.png" />
            </div>
            <div class="description">
              The publisher gets most of all Ad Networks without risks of profit
              decrease & you will buy traffic without commission
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import ReferralLink from './ReferralLink.vue'

export default defineComponent({
  name: 'PublisherReferrals',
  components: {
    ReferralLink
  },
  setup(_props, _context) {
    const domain = 'adspyglass'
    const mainIcons = [
      'exo.png',
      'adsterra.png',
      'hilltopads.png',
      'trafficstars.png',
      'twinred.jpg',
      'adsupply.png'
    ]
    const icons = [
      'adnium_s.png',
      'adxxx_s.png',
      'buymedia_s.png',
      'clickadilla_s.png',
      'clickadu_s.png',
      'clickaine_s.png',
      'ero_s.png',
      'evadav_s.png',
      'juicyads_s.png',
      'monetag_s.png',
      'kadam_s.png',
      'twin_s.png',
      'popcash_s.png',
      'plugrusg_s.png',
      'rivertraffic_s.png',
      'popads_s.png',
      'trafficforce_s.png',
      'trafficshop_s.png',
      'trafficox_s.png',
      'tcorp_s.png'
    ]

    const visible = ref(false)

    const toggleNetworks = () => {
      visible.value = !visible.value
    }

    const btnText = computed(() => {
      if (visible.value) {
        return 'less'
      } else {
        return 'more'
      }
    })

    return { mainIcons, icons, domain, visible, toggleNetworks, btnText }
  }
})
</script>

<style lang="scss" scoped>
.publisher-tab .networks-container.more-networks .network-container {
  width: 17%;
  img {
    width: 30%;
  }
}

.invitation-container {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .invitation {
    display: inline-block;
  }

  .invite-img {
    max-width: 260px;
    height: auto;
  }
}
</style>
